module.exports = "<div class=\"blank\" fusePerfectScrollbar>\n\n    <ticket-invoice [order]=\"order\" [transactions]=\"transactions\" [dueAmount]=\"dueAmount\"></ticket-invoice>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /usr/app/src/app/main/content/app/invoicepage/invoicepage.component.html
// module id = ../../../../../src/app/main/content/app/invoicepage/invoicepage.component.html
// module chunks = main